import type { AllRouteEndpoints } from "../routeTypes";

export const companiesCompanyIdCustomDomainsAppLinkingAssignments =
  "/companies/:company_id/custom_domains/:domain_type/app_linking_assignments";

// Assigning changes a config's embedded assignments, the digest counts, and which tracking domains
// are still assignable — invalidate all three.
export const putCompaniesCompanyIdCustomDomainsAppLinkingAssignmentsCacheKeys: AllRouteEndpoints[] = [
  "/companies/:company_id/mobile_app_linking_configs",
  "/companies/:company_id/mobile_app_linking_configs/:id",
  "/companies/:company_id/mobile_app_linking_assignable_tracking_domains",
];
